module.exports = __webpack_public_path__ + "img/Han-Solo-01-icon.e0fdaed4.png";